<template>
  <v-container class="py-10 py-md-13 py-lg-16">
    <v-row justify="center">
      <v-col cols="12" md="9">
        <TitleWidget color="black" align="center">
          {{ item.title || title }}
        </TitleWidget>

        <img
          v-if="item.img"
          class="d-block mt-6"
          :src="files + item.img + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
          :alt="item.title"
          width="100%"
        />

        <div
          v-if="item.text"
          class="text-subtitle-1 mt-6 ck-content"
          v-html="item.text"
        ></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";

const _config = {
  mod: "about",
};

const _data = {
  title: "Quem Somos",
};

export default {
  data: () => ({
    ..._data,
  }),
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => {
        if (!data.text) this.$router.replace("/error404");

        state.item = data;
      },
    });
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    TitleWidget,
  },
};
</script>
